import React, { useMemo } from 'react';
import Table, { TableProps } from '../Table';

export interface TableSectionProps {
    table?: TableProps;
}

export default function TableSection({ table }: TableSectionProps) {
    const themes = useMemo(() => {
        if (!table?.cols?.find((c) => c.includes('{logo}'))) {
            return null;
        }

        const [firstCol, ...restCols] = table.cols;

        return restCols.map((c) =>
            c.includes('{logo}') ? 'Primary' : 'light',
        );
    }, [table]);

    if (!table) {
        return null;
    }

    return (
        <section className="my-mega">
            <div className="md:container overflow-x-auto md:overflow-x-visible scrollbar-hide">
                <Table
                    {...table}
                    {...(!!themes?.length && { themes })}
                    wrapperClassName="w-full min-w-[750px] [&_.cell:first-child]:pl-margin [&_.cell:last-child]:pr-margin [&_.cell]:md:!px-24 [&_.cell-content]:md:py-16"
                />
            </div>
        </section>
    );
}
